module.exports = __webpack_public_path__ + "static/media/track-barber.a6169d01.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/track-barber.png
// module id = 1027
// module chunks = 0